<template>
  <p :class="value ? 'tw-text-black' : 'tw-text-gray-500'" class="tw-flex tw-items-center">
    <i :class="value ? 'fa-check tw-text-green-500' : 'fa-times tw-text-gray-400'" class="far tw-mr-3 tw-w-2"/>
    {{ translation }}
  </p>
</template>

<script>
export default {
	name: 'PasswordStrenghtIndicator',

	props: {
		value: {
			type: Boolean,
			default: false,
		},
		translation: {
			type: String,
			required: true,
		},
	},
};
</script>